/**
 * PipelinesApiService — API operations for pipelines and stages.
 */

import { ApiClient } from '../ApiClient.js';

export class PipelinesApiService {
    static async list() {
        return ApiClient.get('/api/v1/pipelines');
    }

    static async getById(pipelineId) {
        return ApiClient.get(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}`);
    }

    static async create(payload) {
        return ApiClient.post('/api/v1/pipelines', payload);
    }

    static async update(pipelineId, payload) {
        return ApiClient.put(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}`, payload);
    }

    static async delete(pipelineId) {
        return ApiClient.delete(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}`);
    }

    // Stages
    static async listStages(pipelineId) {
        return ApiClient.get(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}/stages`);
    }

    static async createStage(pipelineId, payload) {
        return ApiClient.post(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}/stages`, payload);
    }

    static async updateStage(pipelineId, stageId, payload) {
        return ApiClient.put(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}/stages/${encodeURIComponent(stageId)}`, payload);
    }

    static async deleteStage(pipelineId, stageId) {
        return ApiClient.delete(`/api/v1/pipelines/${encodeURIComponent(pipelineId)}/stages/${encodeURIComponent(stageId)}`);
    }
}